import { ChangeDetectionStrategy, Component, input } from '@angular/core'
import { Field } from '@models/ui'
import { TranslocoModule } from '@jsverse/transloco'
import { UntilDestroy } from '@ngneat/until-destroy'
import { FieldNameComponent } from '@shared/field-name/field-name.component'

enum CellLabelStyles {
    form = 'form',
    caption = 'caption',
}

@UntilDestroy()
@Component({
    selector: 'app-cell-label',
    imports: [TranslocoModule, FieldNameComponent],
    templateUrl: './cell-label.component.html',
    styleUrl: './cell-label.component.sass',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CellLabelComponent {
    readonly field = input.required<Field>()
    readonly appearance = input<keyof typeof CellLabelStyles>(CellLabelStyles.form)
    readonly viewConfig = input<boolean>(false)

    get labelClass() {
        const classes = {
            [CellLabelStyles.form]: 'body-1',
            [CellLabelStyles.caption]: 'caption-1',
        }

        return [
            classes[this.appearance()],
            this.appearance() === CellLabelStyles.caption ? 'text-textLight' : '',
        ]
    }
}
